module.exports = __webpack_public_path__ + "img/6.97c6b02d.png";